import { useCallback, useState } from 'react';

export interface UseStyleIntelligenceReturn {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export function useStyleIntelligence(): UseStyleIntelligenceReturn {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  return { isOpen, openModal, closeModal };
}
